import { all } from 'redux-saga/effects';

import authSaga from './auth/sagas';
import bookingsSaga from './bookings/sagas';
import customersSaga from './customers/sagas';
import faqSaga from './faq/sagas';
import languageSaga from './language/sagas';
import paymentMethodsSaga from './paymentMethods/sagas';
import referralCouponsSaga from './referralCoupon/sagas';
import regionsSaga from './region/sagas';

export default function* rootSaga() {
  yield all([
    authSaga(),
    bookingsSaga(),
    customersSaga(),
    faqSaga(),
    languageSaga(),
    paymentMethodsSaga(),
    referralCouponsSaga(),
    regionsSaga()
  ]);
}



// WEBPACK FOOTER //
// ./src/store/sagas.js